import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Util.css";
import { List } from "./components/Vehicles/Vehicle_list/List";
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { Dashboard } from "./components/Dashboard";
import { Location } from "./components/Location";
import { Assignment } from "./components/Vehicles/Vehicle_assignment/Assignment";
import { KMHistory } from "./components/Vehicles/Km_history/History";
import { Expense } from "./components/Vehicles/Expenses_history/Expense";
import { FuelHistory } from "./components/Vehicles/Fuel_history/Fuel";


import { NewExpense } from "../src/components/Vehicles/Expenses_history/NewExpense.jsx";
import { WorkOrder } from "./components/Services/Work_Order/WorkOrderList";
import { WorkOrderCreate } from "./components/Services/Work_Order/WorkOrderCreate";
import { WorkOrderView } from "./components/Services/Work_Order/WorkOrderView";
import { ServiceReminder } from "./components/Services/Service_Reminder/ServiceReminderList";
import { RenewalReminder } from "./components/Renewals/Renewal_Reminder/RenewalReminderList";
import { UpcomingReminder } from "./components/Renewals/Upcoming_Reminder/UpcomingReminderList";
import { VendorList } from "./components/Vendor/VendorList";
import { UserList } from "./components/User/UserList";
import { useGlobal } from "./GlobalContext";
import axios from "axios";
import { getCookie } from "./components/getcookie";
import PreLanding from "./pre-landing";
import UnAuthorized from "./components/unauthorized";
import { Issue } from "./components/Issue/Issue.jsx";
import { ViewIssue } from "./components/Issue/ViewIssue.jsx";
import { ViewService } from "./components/Services/Service/ViewService.jsx";
import { AddService } from "./components/Services/Service/AddService.jsx";
import { Service } from "./components/Services/Service/Service.jsx";
import { ViewVendor } from "./components/Vendor/ViewVendor.jsx";
import { AddVendor } from "./components/Vendor/AddVendor.jsx";
import { Inspection } from "./components/Inspection/Inspection.jsx";
import { AddInspection } from "./components/Inspection/AddInspection.jsx";
import { ViewInspection } from "./components/Inspection/ViewInspection.jsx";
import { Report } from "./components/report/Report.jsx";
import { ViewSecondaryInspection } from "./components/Inspection/ViewSecondaryInspection.jsx";
import HelpQuestions from "./components/common/help";
import { Layout } from "./components/common/Layout";
import { getOrgLogoApi } from "./components/dashboard_api.js";
import PoweredBy from "./components/common/common_powered_by.jsx";
import { NewVehicle } from "./components/Vehicles/Vehicle_list/vehicle-create.jsx";
import { VehicleDetails } from "./components/Vehicles/Vehicle_list/vehicle-view.jsx";

function App() {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const location = useLocation();
  // List of paths where header should be hidden
  const hideHeaderPaths = ["/"];

  const shouldHideHeader = hideHeaderPaths.includes(location.pathname);
  const { rolePermissionList, setRolePermissionList, userType, setUserType, setOrgImage } = useGlobal();
  useEffect(() => {
    const checkToken = async () => {
      try {
        console.log("🔍 Checking token validity...");

        const response = await axios.get(adminApiUrl + "validatetoken", {
          headers: { Authorization: getCookie("mawalog") },
        });

        console.log("✅ Token status:", response.status);

        if (response.status === 401) {
          handleInvalidToken();
        }
      } catch (err) {
        console.error("❌ Token validation failed:", err);
        handleInvalidToken();
      }
    };

    const handleInvalidToken = () => {
      const currentURL = window.location.href;

      const redirectData = {
        redirectPath: currentURL,
        app: "vehicle",
        ts: Date.now(),
      };

      console.warn("🔐 Saving redirect in window.name:", redirectData);

      // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
      window.name = JSON.stringify(redirectData);

      console.log("📌 window.name set:", window.name);

      // Clear token
      document.cookie = "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      console.log("➡️ Redirecting to login:", `${accountsUrl}/login`);
      window.location.href = `${accountsUrl}/login`;
    };

    // 🔥 IMPORTANT: run once on load
    console.log("🚀 Initial token check");
    checkToken();

    // Recheck when tab regains focus
    const onFocus = () => {
      console.log("👁 Window focused → rechecking token");
      checkToken();
    };

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);
  useEffect(() => {
    getRolePermission();
    getOrgLogo();
  }, []);
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        setOrgImage(response.image ?? "");
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  useEffect(() => {
    const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);

    channel.onmessage = () => {
      window.location.reload();
    };

    return () => channel.close();
  }, []);

  const [loading, setLoading] = useState(true);
  const getRolePermission = async () => {
    try {
      const response = await axios
        .get(adminApiUrl + "get_role_permission/2", {
          params: {},
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*", // Required for CORS support to work
            Authorization: getCookie("mawalog"),
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.success === true) {
              setUserType(response.data.user_type);
              setRolePermissionList(response.data.role_permission ?? []);
              localStorage.setItem("rolePermissionList", JSON.stringify(response.data.role_permission ?? []));
              localStorage.setItem("userType", response.data.user_type ?? "");
            } else {
              setRolePermissionList([]);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 401) {
              const currentURL = window.location.href;

              const redirectData = {
                redirectPath: currentURL,
                app: "transport",
                ts: Date.now(),
              };

              console.warn("🔐 Saving redirect in window.name:", redirectData);

              // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
              window.name = JSON.stringify(redirectData);
              window.location.href = `${accountsUrl}/login`;
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });

      // const data = await response.json();
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
      setLoading(false);
    }
  };

  function checkPermission(menuName, permission) {
    console.log(rolePermissionList);
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  const ProtectedRoute = ({ isAllowed }) => {
    console.log("isAllowed", isAllowed);
    return isAllowed ? <Outlet /> : <Navigate to="/unauthorized" />;
  };

  return (
    <>
      {/* <BrowserRouter> */}
      {loading ? (
        <p></p>
      ) : (
        <>
          <Routes>
            {/* Routes without Layout */}
            <Route path="/" element={<PreLanding />} />
            <Route path="/unauthorized" element={<UnAuthorized />} />
            <Route path="/help" element={<HelpQuestions />} />
            {/* Routes with Layout (Sidebar + Navbar) */}
            <Route element={<Layout />}>
              {/* Dashboard */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Dashboard", "menu_permission")} />}>
                <Route path="/dashboard" element={<Dashboard />} />
              </Route>

              {/* Location Detection */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Location detection", "menu_permission")} />}>
                <Route path="/location" element={<Location />} />
              </Route>

              {/* Vehicle List */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vehicle", "list_permission")} />}>
                <Route path="/list" element={<List />} />
              </Route>

              {/* New Vehicle */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vehicle", "create_permission")} />}>
                <Route path="/vehicle-create" element={<NewVehicle />} />
              </Route>

              {/* Vehicle Details */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vehicle", "view_permission")} />}>
                <Route path="/vehicle-view" element={<VehicleDetails />} />
              </Route>

              {/* Vehicle Assignment */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vehicle assignment", "list_permission")} />}>
                <Route path="/assignment" element={<Assignment />} />
              </Route>
              {/* Expenses History */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Expenses history", "list_permission")} />}>
                <Route path="/expenses" element={<Expense />} />
              </Route>

              {/* New Expense */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Expenses history", "create_permission")} />}>
                <Route path="/newExpense" element={<NewExpense />} />
              </Route>

              {/* KM History */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("KM History", "list_permission")} />}>
                <Route path="/km" element={<KMHistory />} />
              </Route>

              {/* Fuel History */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Fuel History", "list_permission")} />}>
                <Route path="/fuel" element={<FuelHistory />} />
              </Route>

              {/* Work Order List */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Work Order", "list_permission")} />}>
                <Route path="/workorder" element={<WorkOrder />} />
              </Route>

              {/* Work Order Create */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Work Order", "create_permission")} />}>
                <Route path="/workorder/create" element={<WorkOrderCreate />} />
              </Route>

              {/* Work Order View */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Work Order", "view_permission")} />}>
                <Route path="/workorder/view" element={<WorkOrderView />} />
              </Route>

              {/* Service Reminder */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Service Reminders", "list_permission")} />}>
                <Route path="/reminder" element={<ServiceReminder />} />
              </Route>

              {/* Renewal Reminder */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Renewal", "list_permission")} />}>
                <Route path="/renewal" element={<RenewalReminder />} />
              </Route>

              {/* Upcoming Reminder */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Renewal", "list_permission")} />}>
                <Route path="/upcoming" element={<UpcomingReminder />} />
              </Route>

              {/* Issue History */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Issue History", "list_permission")} />}>
                <Route path="/issue-history" element={<Issue />} />
              </Route>

              {/* View Issue */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Issue History", "view_permission")} />}>
                <Route path="/viewIssue" element={<ViewIssue />} />
              </Route>

              {/* Service List */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Service", "list_permission")} />}>
                <Route path="/service" element={<Service />} />
              </Route>

              {/* Add Service */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Service", "create_permission")} />}>
                <Route path="/service/create" element={<AddService />} />
              </Route>

              {/* View Service */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Service", "view_permission")} />}>
                <Route path="/viewService" element={<ViewService />} />
              </Route>

              {/* Vendor List */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vendor", "list_permission")} />}>
                <Route path="/vendor" element={<VendorList />} />
              </Route>

              {/* View Vendor */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vendor", "view_permission")} />}>
                <Route path="/vendor/view" element={<ViewVendor />} />
              </Route>

              {/* Add Vendor */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vendor", "create_permission")} />}>
                <Route path="/vendor/create" element={<AddVendor />} />
              </Route>

              {/* Inspection List */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Inspection History", "list_permission")} />}>
                <Route path="/inspection" element={<Inspection />} />
              </Route>

              {/* Add Inspection */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Inspection History", "create_permission")} />}>
                <Route path="/inspection/create" element={<AddInspection />} />
              </Route>

              {/* View Inspection */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Inspection History", "view_permission")} />}>
                <Route path="/inspection/view" element={<ViewInspection />} />
              </Route>

              {/* View Secondary Inspection */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Inspection History", "view_permission")} />}>
                <Route path="/inspection-history/view" element={<ViewSecondaryInspection />} />
              </Route>

              {/* Report */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Report", "list_permission")} />}>
                <Route path="/report" element={<Report />} />
              </Route>


            </Route>

          </Routes>
          {location.pathname !== "/help" && <PoweredBy />}
        </>


      )}
      {/*  </BrowserRouter> */}
    </>
  );
}

export default App;
